export type CalendarUnitsToPick = 'day' | 'month' | 'year';

export type DateFormat = 'DD/MM/YYYY' | 'MM/YYYY' | 'YYYY';
export const CALENDAR_DATE_FORMAT_MAP: Record<CalendarUnitsToPick, DateFormat> = {
  day: 'DD/MM/YYYY',
  month: 'MM/YYYY',
  year: 'YYYY',
};
